import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { setInitialStoreState } from '../../../../common/utils';
import { ShipmentLoadItemFacade } from './shipment-load-item.facade';
import { Injectable } from '@angular/core';
import { LoadIdView } from '../../../models';
import { Permission, PERMISSION_CONFIG } from '../../../../common';
import { AuthFacade } from '../../auth';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadItemGuard {
  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      queryParams: { loadNumber = null },
    } = route;
    const identifier: LoadIdView = { loadNumber };

    this.shipmentLoadItemFacade.setShipmentLoadIdentifier(identifier);
    this.shipmentLoadItemFacade.loadShipmentLoadDemurrageAndDetentionTab(identifier);

    return this.authFacade
      .hasPermission$(
        PERMISSION_CONFIG[Permission.TrackAndTrace][Permission.CanaryTransportLevel][Permission.ShipmentCustoms][
          Permission.Read
        ],
      )
      .pipe(
        switchMap(() => {
          return of(true);
        }),
      );
  }

  constructor(private shipmentLoadItemFacade: ShipmentLoadItemFacade, private authFacade: AuthFacade) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentLoadItemFacade);
  }
}
